import { useQuery } from '@tanstack/react-query';

const useFortressQuery = (queryOptions = {}) => {
  const isQueryEnabled = Boolean(queryOptions.enabled ?? true);

  const query = useQuery({
    ...queryOptions,
    enabled: isQueryEnabled,
  });

  const hasResolvedData = Boolean(
    (query.isFetched || query.isSuccess) && !query.isPlaceholderData,
  );

  // Block only on first real load. Cached/placeholder-backed background fetches stay non-blocking.
  const isBlockingLoading = Boolean(
    isQueryEnabled && !hasResolvedData && query.fetchStatus === 'fetching',
  );

  const isRefreshing = Boolean(
    isQueryEnabled && hasResolvedData && query.fetchStatus === 'fetching',
  );

  return {
    ...query,
    isQueryEnabled,
    hasResolvedData,
    isBlockingLoading,
    isRefreshing,
    queryIsLoading: query.isLoading,
    isLoading: isBlockingLoading,
  };
};

export default useFortressQuery;
